import { InputsFinalize } from "./InputsFinalize";

export interface SaveAccountIncomeData {
  name: string;
  lastName: string;
  email: string;
  phone: string;
  city: string;
  street: string;
  houseNumber: string;
  flatNumber: string;
  zipCode: string;
  NIP: string;
  companyName: string;
  createUser: boolean | string;
  createInvoice: boolean | string;
}

export const setSaveAccountIncomeData = (data: InputsFinalize) => {
  return {
    name: data.firstName ?? "",
    lastName: data.lastName ?? "",
    email: data.email ?? "",
    phone: data.phone ?? "",
    city: data.city ?? "",
    street: data.street ?? "",
    houseNumber: data.houseNumber ?? "",
    flatNumber: data.flatNumber ?? "",
    zipCode: data.zipCode ?? "",
    NIP: data.NIP ?? "",
    companyName: data.companyName ?? "",
    createUser: data.createUser ? "true" : "false",
    createInvoice: data.createInvoice ? "true" : "false",
  } as SaveAccountIncomeData;
};
